import { Record } from 'immutable'

export class DriversType extends Record({
    id: undefined,
    name: undefined,
}) {}
